const FEE_TYPE = {
  PERCENTAGE: 'Percentage',
  FLAT_FEE: 'Flat Fee'
};

export { FEE_TYPE };
